"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDoiChangesAreBlockingSave = exports.getDoiConfirmationPageChangesAreBlocking = exports.getSaveChangesRequestStatus = void 0;

var _reselect = require("reselect");

var _constants = require("settings-ui-sdk/DoiSettings/constants");

var _constants2 = require("settings-ui-sdk/SiteSettings/constants");

var _selectors = require("settings-ui-sdk/SubscriptionEmails/selectors");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _SaveActions = require("../actions/SaveActions");

var _UpdateDoiPages = _interopRequireWildcard(require("../stagedObjects/UpdateDoiPages"));

var _UpdateDoiSettings = _interopRequireDefault(require("../stagedObjects/UpdateDoiSettings"));

var _UpdateEmailSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateEmailSiteSettings"));

var getSaveChangesRequestStatus = (0, _getRequestStatus.default)(_SaveActions.SaveChangesActionTypes.SAVE_CHANGES);
exports.getSaveChangesRequestStatus = getSaveChangesRequestStatus;
var getDoiEnabled = (0, _reselect.createSelector)([_UpdateDoiSettings.default.getStagedProperty(_constants.ENABLED), _UpdateDoiPages.default.getStagedProperty(_UpdateDoiPages.HAS_WHITELISTED_ITEMS)], function (enabledForAll, hasWhitelistedItems) {
  return enabledForAll || hasWhitelistedItems;
});
var getDoiEmailRelatedChangesAreBlocking = (0, _reselect.createSelector)([getDoiEnabled, _UpdateDoiSettings.default.getStagedProperty(_constants.WELCOME_EMAIL_ENABLED), _selectors.getOptinSubscriptionEmail, _selectors.getOptinFollowupSubscriptionEmail], function (enabled, followupEmailEnabled, optinEmail, followupEmail) {
  var disabled = false;

  if (enabled) {
    disabled = disabled || !(optinEmail && optinEmail.getIsPublished());
  }

  if (followupEmailEnabled) {
    disabled = disabled || !(followupEmail && followupEmail.getIsPublished());
  }

  return disabled;
});
var getDoiPageRelatedChangesAreBlocking = (0, _reselect.createSelector)([_UpdateDoiPages.default.getStagedObject], function (stagedDoiPages) {
  var values = stagedDoiPages.get(_UpdateDoiPages.VALUES);

  if (stagedDoiPages.get(_UpdateDoiPages.HAS_BLACKLISTED_ITEMS) && !(0, _UpdateDoiPages.containsBlacklistedItems)(values)) {
    return true;
  }

  if (stagedDoiPages.get(_UpdateDoiPages.HAS_WHITELISTED_ITEMS) && !(0, _UpdateDoiPages.containsWhitelistedItems)(values)) {
    return true;
  }

  return false;
});
var getDoiConfirmationPageChangesAreBlocking = (0, _reselect.createSelector)([_UpdateEmailSiteSettings.default.getStagedProperty(_constants2.EMAIL_OPTIN_CONFIRMATION_PAGE_ID)], function (confirmationId) {
  return confirmationId === null || confirmationId === '';
});
exports.getDoiConfirmationPageChangesAreBlocking = getDoiConfirmationPageChangesAreBlocking;
var getDoiChangesAreBlockingSave = (0, _reselect.createSelector)([getDoiEnabled, getDoiEmailRelatedChangesAreBlocking, getDoiConfirmationPageChangesAreBlocking, getDoiPageRelatedChangesAreBlocking], function (doiEnabled, emailRelatedAreBlocking, confirmationChangesAreBlocking, pageRelatedAreBlocking) {
  if (!doiEnabled) {
    return false;
  }

  return emailRelatedAreBlocking || confirmationChangesAreBlocking || pageRelatedAreBlocking;
});
exports.getDoiChangesAreBlockingSave = getDoiChangesAreBlockingSave;